<div class="table">
    <mat-table [dataSource]="dataSource" matSort>
        <ng-container [matColumnDef]="column.key" *ngFor="let column of displayedColumns">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{column.viewValue | uppercase}}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div [ngSwitch]="column?.type">
                    <ng-container *ngSwitchCase="'text'">
                        <div [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')" *ngIf="isArray(row[column.key]); else nonArrayBlock">
                            <ng-container *ngIf="column?.avatar?.columnKey === column?.key; else noAvatarBlock">
                                <ng-container *ngIf="row[column.key]?.length === 1;else multiValue">
                                    <div>
                                        <span *ngFor="let value of row[column.key]; let i=index" class="stackedAvatars d-flex align-items-center">
                                            <ngx-avatar [name]="value || 'XYZ'" src="assets/svg/avatar-photo.jpg" size="24"
                                                [round]="true">
                                            </ngx-avatar>
                                            <p class="ps-2 mb-0">{{value || 'XYZ'}}</p>
                                        </span>
                                    </div>
                                </ng-container>
                                <ng-template #multiValue>
                                    <div class="d-flex">
                                        <span *ngFor="let value of row[column.key].slice(0, 5); let i=index" class="stackedAvatars" [style.transform]="('translateX(' + (-1 * i * 10) + 'px)')">
                                            <ngx-avatar [matTooltip]="value || 'XYZ'" [name]="value || 'XYZ'" src="assets/svg/avatar-photo.jpg" size="24"
                                                [round]="true">
                                            </ngx-avatar>
                                        </span>
                                        <span *ngIf="row[column.key]?.length > 5" class="stackedAvatars">
                                            <ngx-avatar [name]="'+ '+(row[column.key]?.length - 5).toString()" src="assets/svg/avatar-photo.jpg" size="24"
                                                [round]="true">
                                            </ngx-avatar>
                                        </span>
                                    </div>
                                </ng-template>
    
                            </ng-container>
                            <ng-template #noAvatarBlock>
                                <ng-container *ngFor="let value of row[column.key]">
                                    {{value}}
                                </ng-container>
                            </ng-template>
                        </div>
                        <ng-template #nonArrayBlock>
                            <div class="d-flex flex-row gap-1 align-items-center">
                                <img *ngIf="column?.icon?.columnKey === column?.key && column?.icon?.bShow" [src]="column.icon?.imgSrc" alt="icon">
                                <span [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                                    {{row[column.key]}}
                                </span>
                            </div>
                            
                        </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="'number'">
                        <div [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                            {{row[column.key]}}
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'currency'">
                        <div [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                            {{row[column.key] | currency: currency}}
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'date'">
                        <div [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                            {{row[column.key] | date:'mediumDate'}}
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'button'">
                        <div class="cell-button">
                            <button [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')"> {{row[column.key]}}</button>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'pill'">
                        <app-badge-pill [text]="row[column.key]"
                                [color]="getBadgePillColor(row[column.key])" [class]="getBadgePillColor(row[column.key])">
                        </app-badge-pill>
                    </ng-container>

                    <!-- TODO: For future use -->
                    <ng-container *ngSwitchCase="'badge'">
                        
                        <div [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                            <app-status-indicator [status]="row[column.key]"></app-status-indicator>
                            <!-- <div *ngIf="row[column.key] === 'delivered'" class="badge-group"><img src="assets/svg/completed-badge-filled.svg" alt="Delivered"></div>
                            <div *ngIf="row[column.key] === 'in_transit'" class="badge-group"><img src="assets/svg/in-transit-badge.svg" alt="In transit"></div>
                            <div *ngIf="row[column.key] === 'shipped'" class="badge-group"><img src="assets/svg/shipped-badge.svg" alt="Shipped"></div>
                            <div *ngIf="row[column.key] === null" class="badge-group"><img src="assets/svg/shipped-badge.svg" alt="Shipped"></div> -->
                        </div>
                    </ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Action column to show text/svg-icon-img/button -->
        <ng-container *ngIf="actionColumn?.bShow" matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="light-text pl-0">{{actionColumn?.header}}</mat-header-cell>
            <mat-cell class=" pl-0" *matCellDef="let element">
                <span (click)="actionCellClick(element)" class="pointer mb-0 d-flex flex-row gap-1">
                    <img *ngIf="actionColumn?.icon?.bShow" [src]="actionColumn?.icon?.svgPath" alt="action icon">
                    <p *ngIf="actionColumn?.title !== ''" [matTooltip]="actionColumn?.toolTip" [class]="actionColumn?.class" class="mb-0">{{actionColumn?.title}}</p>
                    <div *ngIf="actionColumn?.button?.bShow" class="cell-button" [matTooltip]="actionColumn?.button?.toolTip">
                        <button [class]="actionColumn?.button?.class"> {{actionColumn?.button?.text}}</button>
                    </div>
                </span>
            </mat-cell>
        </ng-container>

        <!-- Header for table -->
        <mat-header-row *matHeaderRowDef="columnsDefs"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsDefs;"></mat-row>
        <mat-row *matNoDataRow [hidden]="loading"="let row; columns: columnsDefs;">
            <mat-cell class="text-center" [attr.colspan]="displayedColumns.length">
                No data matching the filter
            </mat-cell>
        </mat-row>
    </mat-table>
    <mat-paginator #paginator
    class="d-flex justify-content-center"
    [length]="total_count" 
    [pageSize]="page_size"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions" 
    (page)="paginationChange($event)">
    </mat-paginator>
</div>